module.exports = __webpack_public_path__ + "img/shop-front-mobile.f088e78d.png";